import customAxios from "./axiosConfig";

const InvoiceService = {
  list (params) {
    const api_url = window.Urls['invoice-list']();
    return customAxios.get(api_url, { params: params });
  },
  loadNextPage (next_url) {
    return customAxios.get(next_url);
  },
  getPayment (payment_id) {
    const api_url = '/api/v2/invoice-payments/' + payment_id + '/'
    return customAxios.get(api_url);
  },
  retrieve (pk, params) {
    const api_url = window.Urls["invoice_detail"](pk);
    return customAxios.get(api_url, { params: params });
  },
  sendReport (pk, data) {
    const api_url = window.Urls['invoice_send_report'](pk);
    return customAxios.post(api_url, data);
  },
  getEmailReport (email_id) {
    const api_url = '/api/v2/email_message/' + email_id + '/'
    return customAxios.get(api_url);
  },
  emailIgnoreFailure (email_id) {
    const api_url = '/api/v2/email_message/' + email_id + '/ignore_faliure/'
    return customAxios.post(api_url);
  },
  getPeriodOptions (params) {
    const api_url = window.Urls['invoice-years']();
    return customAxios.get(api_url, { params: params });
  },
  customerList (params) {
    const api_url = window.Urls['invoice_customer_list']();
    return customAxios.get(api_url, { params: params });
  },
  convertTotal (id, total_amount) {
    const api_url = window.Urls['invoice-convert-total'](id);
    return customAxios.get(api_url, total_amount);
  },
  createPaidInvoice (data) {
    const api_url = window.Urls['invoice_create_paid_invoice']();
    return customAxios.post(api_url, data);
  },
  downloadUrl(invoice_id) {
    return window.Urls['invoices_pdf'](invoice_id);
  },
  getPremiumInvoices(params) {
    var api_url = window.Urls['invoice_get_premium_invoices']();
    return customAxios.get(api_url, {params: params});
  },
  createCredit (pk) {
    const api_url = window.Urls['invoice-create-credit'](pk);
    return customAxios.post(api_url);
  },
  destroy (pk) {
    const api_url = window.Urls['invoice-detail'](pk);
    return customAxios.delete(api_url);
  },
  copyInvoice (pk, data) {
    const api_url = window.Urls['invoice-copy'](pk);
    return customAxios.post(api_url, data);
  },
  totalAmounts: function (params) {
    var api_url = window.Urls["invoice_totals"]();
    return customAxios.get(api_url, {params: params});
},
}

export default InvoiceService;
